// extracted by mini-css-extract-plugin
module.exports = {"quote":"_2GEg-LGHHWo0c8qTwFH-ct","work":"_2M9D63-ZtbCXScT1qCkaB5","quoteImage":"_20043A9Qs5hsjdhGdkkQmM","logo":"_1CdpbjczUH6prH0K4369uQ"};